<template>
    <div class="cust-toast"
         :class="type"
         v-if="showToast">
        <span class="icon">
            <img v-lazy="iconSrc" v-if="iconSrc"/>
        </span>
        {{ message }}
    </div>
</template>

<script>
export default {
  /**
   * params: showToast Boolean  是否激活toast  默认 false
   * params: type String        toast提示类型  共 success，error，warning cancel 四个选项
   * params: message String     toast消息
   * params: duration Number    toast显示时间 默认 3000ms
   * */
  name: "Toast",
  data() {
    return {
      showToast: false,
      type: '',
      message: "消息提示",
      duration: 3000
    }
  },
  computed: {
    iconSrc() {
      let _type = ["success", "warning", "error", "cancel","kfz"];
      return _type.includes(this.type) ? require(`./icons/${this.type}.png`) : ''
    }
  },
}
</script>

<style scoped>
.cust-toast {
    position: fixed;
    left: 50%;
    top: 80px;
    background: rgb(245, 245, 245);
    height: 40px;
    width: 820px;
    border-radius: 4px;
    transform: translate(-50%, -50%);
    animation: show-toast .3s;
    color: #666666;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999999;
}

@keyframes show-toast {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.success {
    color: #78C06E;
    background: rgb(240, 249, 235);
}

.warning {
    color: #F7AB01;
    background: rgb(253, 246, 236);
}

.error {
    color: #E1251B;
    background: rgb(255, 238, 238);
}

.cancel {
  color: #666666;
  background: rgb(245, 245, 245);
}
.kfz {
  color: #FFFFFF;
  background: rgba(0, 0, 0, 0.6);
}

.icon img {
    margin-top: 4px;
    margin-right: 10px;
}

</style>
